module.exports = __webpack_public_path__ + "static/img/img_logo.2f5b68dd.png";